module.exports = __webpack_public_path__ + "static/media/placeholder.81fea689.png";